import React, { Component } from 'react';
import * as GServ from '../services/GatewayService';
import { CircularProgress, Button, TextField } from '@material-ui/core';

function mobileValid (mobile) {
    if (/^\d{10}$/.test(mobile)){
      if ((mobile.substring(0, 3)==="010" || mobile.substring(0, 2)==="08" || mobile.substring(0, 2)==="07" || mobile.substring(0, 2)==="06" || mobile.substring(0, 2)==="07")&& !(mobile.substring(0, 3)==="086" || mobile.substring(0, 3)==="088" || mobile.substring(0, 3)==="089") ){
        return true
      } else {
        return false;
      }
    } else {
      return false;
    } 
}

export default class MobileConf extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: false,
            status: this.props.mobile_match? '' : 'Please enter mobile number...',
            warning: '',
            mobile_num: '',
            m_pholder: 'Mobile Number (Cell)',
            canSubmit: true,
            showOTPField: false,
            otpPlaceholder: 'One-Time-Pin',
            otp_value: '',
            retry_count: 0,
        }
    }

    render() {
        
        return (
            <div>
                {!this.state.showOTPField&&
                <div>
                    <h3>Mobile Number Verification...</h3>
                    <form name="NameNumber" method="POST" onSubmit={this.submitHandler}>
                    
                        {this.props.mobile_match&&
                        <p>We need to send a <b>One-Time-Pin (OTP)</b> to your mobile number, so we can safely change your your email address.<br/><br/>Your One-Time-Pin will be sent to: <b>{this.props.mobile}</b></p>}

                        {!this.props.mobile_match&&
                        <span>
                            <p>We need to send a <b>One-Time-Pin (OTP)</b> to the mobile number provided when your details were first created, so we can safely change your your email address.<br/><br/>Please confirm your original mobile number below - your OTP will be sent to this number ({this.props.old_mobile})</p>

                            <TextField 
                                variant='outlined'
                                disabled={!this.state.canSubmit}
                                type="tel"
                                id="mobile"
                                name="mobile"
                                label={this.state.m_pholder}
                                value={this.state.mobile_num}
                                // onFocus={()=> this.setState({m_pholder:'',status:'',warning:''})}
                                // onBlur={()=> this.setState({m_pholder:'Mobile Number (Cell)',status:''})}
                                onChange={this.fieldHandler}  
                                InputProps={{pattern:"[0-9]{10}"}}
                                required
                                title="Please enter your 10 digit mobile (cell) number without any spaces e.g. 0821234567" autoComplete='off'
                                autoCorrect='off'
                                autoCapitalize='off'
                                style={{width:'40%', minWidth:'250px', marginTop:'10px'}}
                            />
                            <br/>
                            {/* <div className="prime_input">
                                <input disabled={!this.state.canSubmit} type="tel" id="mobile" name="mobile" placeholder={this.state.m_pholder} value={this.state.mobile_num} onFocus={()=> this.setState({m_pholder:'',status:'',warning:''})} onChange={this.fieldHandler} onBlur={()=> this.setState({m_pholder:'Mobile Number (Cell)',status:''})} pattern="[0-9]{10}" required title="Please enter your 10 digit mobile (cell) number without any spaces e.g. 0821234567" autoComplete='off' autoCorrect='off' autoCapitalize='off'/>
                            </div> */}
                        </span>}
                        <Button 
                            variant='contained'
                            size='large'
                            color='primary'
                            id="Submit"
                            type='submit'
                            disabled={!this.state.canSubmit}
                            syle={{marginTop:'15px'}}
                        >
                            <span id="s1" >{this.props.mobile_match? 'Continue' : 'Submit'}</span>
                        </Button>
                        {/* <button id="Submit" className="button" style={{verticalAlign:'middle'}} disabled={!this.state.canSubmit}><span id="s1" >{this.props.mobile_match? 'Continue' : 'Submit'}</span></button> */}
                    </form>
                
                    {!this.props.mobile_match&&
                    <p>
                        <i>Note: If your mobile number has changed and you don't have access to the original number, please contact us.</i>
                    </p>}
                </div>}

                {this.state.showOTPField&&
                <div>
                    <p>Please enter the One-Time-Pin(OTP) we sent to <b>{this.props.mobile_match? this.props.mobile : this.state.mobile_num}</b></p>
                    <form name="OTP" method="POST" onSubmit={this.otpSubmitHandler}>

                        <TextField
                            variant='outlined'
                            type="number"
                            id="otp"
                            name="otp"
                            label={this.state.otpPlaceholder}
                            value={this.state.otp_value}
                            autoFocus={true}
                            // onFocus={()=> this.setState({otpPlaceholder:'',status:''})}
                            // onBlur={()=> this.setState({otpPlaceholder:'One-Time-Pin',status:''})}
                            onChange={this.fieldHandler}
                            required
                            autoComplete="off"
                            disabled={!this.state.canSubmit}
                            style={{width:'25%', minWidth:'100px', marginTop:'10px'}}
                        />

                        {/* <div className="prime_input">
                            <input type="text" id="otp" name="otp" placeholder={this.state.otpPlaceholder} value={this.state.otp_value} autoFocus={true} onFocus={()=> this.setState({otpPlaceholder:'',status:''})} onBlur={()=> this.setState({otpPlaceholder:'One-Time-Pin',status:''})} onChange={this.fieldHandler} required pattern="\d*" autoComplete="off" minLength={5} maxLength={5} disabled={!this.state.canSubmit}/>
                        </div> */}
                        <br/><br/>
                        <Button 
                            variant='contained'
                            size='large'
                            color='primary'
                            id="Submit"
                            disabled={!this.state.canSubmit}
                            type='submit'
                            syle={{marginTop:'15px'}}
                        >
                            <span id="s1" >Submit</span>
                        </Button>
                        {/* <button id="Submit" className="button" style={{verticalAlign:'middle'}} disabled={!this.state.canSubmit}><span id="s1" >Submit</span></button> */}
                    </form>
                </div>}

                <hr/>
                <span id="StatusBar" className="StatusBar">
                    {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp;
                    {this.state.status}
                </span>
                <span className='warningMessage'>{this.state.warning}</span>
            </div>
        );

    }
    
    submitHandler = (e) => {

        e.preventDefault();

        const Mobile = this.state.mobile_num;
        const retryCount = this.state.retry_count + 1;

        if (!this.props.mobile_match && !mobileValid(Mobile)){
            this.setState({status:'',warning:"The mobile (cell) number you have entered does not appear to be a mobile number...please enter a valid mobile number"});
            return false;
        
        } else if (!this.props.mobile_match && Mobile==="0821234567"){
            this.setState({status:'',warning:"You seem to have entered our sample mobile number by mistake...please enter your mobile (cell) number"});
            return false;

        } else {

            // console.log('Good to go...');
            const dataObj = {
                already_matched : this.props.mobile_match,
                destination : this.props.mobile_match? this.props.mobile : this.state.mobile_num,
                old_user_token : this.props.old_user_token,
                institution_name : this.props.institution_name,
                contact_phone : this.props.contact_phone
            };
            this.setState({status:"processing...",warning:'',showSpinner:true,canSubmit:false});
            GServ.requestMobileOTP(this.props.gwt,dataObj)
            .then(reply => {
                if (reply.Result === 'Success'){
                    this.setState({status:'',showOTPField:true,canSubmit:true,showSpinner:false,retry_count:0});
                } else if ((reply.Message=== 'mobile number does not match')&&(this.state.retry_count<3)){
                    this.setState({status:'',warning:'The number you have entered does not match our records. Please try again. If this problem persists, please contact us.',showSpinner:false,canSubmit:true,retry_count:retryCount});
                } else {
                    // console.log('Failed response received on mobile OTP request => ',reply)
                    this.setState({status:'',warning:'Technical error encountered - we were unable to send you a one-time-pin (OTP). If this problem persists, please contact us.',showSpinner:false})
                }
                return true;
            });
            // this.props.setParentState({fname:fName,lname:lName,mobile:Mobile,showNameNum:false,showOTPDialogue:true});
        }
    }

    otpSubmitHandler = (e) => {
        const retryCount = this.state.retry_count + 1;
        e.preventDefault();
        const dataObj = {
            old_user_token : this.props.old_user_token,
            operation : 'update contact_email',
            otp: this.state.otp_value,
        };
        this.setState({status:"processing...",warning:'',showSpinner:true,canSubmit:false});
        GServ.submitMobileOTP(this.props.gwt,dataObj)
        .then(reply => {
            // console.log('Server reply on submitMobileOTP => ',reply);
            if (reply.Result === 'Success'){
                //OTP successful - assume email change has happened too... can proceed to open main form if status of user is 'HasID', otherwise go to ID capture...
                //NB: Need to update gwt too!
                
                this.props.setParentState({form_token:reply.Form_Token, gwt: reply.GWT});
                
                if (reply.UserStatus === 'HasID'){
                    
                    //now to head back again to check app status...
                    // this.props.setParentState({showMobileConf:false,showMainForm:true});
                    this.props.setParentState({showMobileConf:false,showCheckAppStatus:true});
                    
                } else {
                    //User doesn't seem to have an ID - problematic, we shouldn't be here as we've already picked up a duplicate ID... need to revert to regret page...
                    // console.log('Returned user and formToken doesn`t seem to have a valid ID...');
                    this.props.setParentState({showMobileConf:false,showRegret:true});
                }

            } else if (reply.Message.includes('OTP invalid') && (this.state.retry_count<3)){
                //OTP number doesn't match - can retry up to 3 times...
                this.setState({status:'',warning:'The OTP you have entered does not match - please check and re-enter...',showSpinner:false,canSubmit:true,retry_count:retryCount});
            } else {
                //Either there was an error making the email address change on old user, or otherwise the OTP has been entered incorrectly three times
                // console.log('Failed response received on mobile OTP submission => ',reply);
                this.setState({status:'',warning:'Technical error encountered - we were process the requested change of email address. If this problem persists, please contact us.',showSpinner:false})
            }
            return true;
        });
    }

    fieldHandler = (e) => {
        if (e.target.name==='mobile'){this.setState({mobile_num:e.target.value})}
        if (e.target.name==='otp'){this.setState({otp_value:e.target.value})}
    }

}
